import React, { Component } from "react";
import { Link } from "react-router-dom";
import { decode as base64_decode, encode as base64_encode } from "base-64";

import { observer } from "mobx-react";
import withRouter from "../withRouter";
import { StoreContext } from "../store/RootStore";
import HelpModal from "./HelpModal";
import { Tooltip,Button, Image, Typography,Spin} from "antd";
import Cookies from "universal-cookie";
import conf from "../config";
import { Helmet } from "react-helmet";
import drive7Icon from "../../src/assets/images/drive7.ico";
import awtlIcon from "../../src/assets/images/awtl.ico";
import starlingIcon from "../../src/assets/images/starling.ico";
import secureIcon from '../../src/assets/images/secure.ico';
import DistributorFleetCountStore from "../store/DistributorFleetCountStore";
const { Title } = Typography;
class CertificateOtherCategories extends Component {
  constructor(props) {
    super(props);
    this.cookies = new Cookies();
    this.DistributorFleetCountStore = new DistributorFleetCountStore(this);
    // this.mapShow = Number(
    //   JSON.parse(JSON.stringifythis.cookies.get("mapShow"))
    // );
     this.state = {
      name:'',
       loading:false
    };
    this.showLaunchingItems = {
      livetracking: false,
      dashboard: false,
      historytracking: false,
      detailtracking: false,
      parentalertreportlist: false,
      master: false,
      AdvanceDashboard: false,
      vehiclelist: false,
      parentreport: false,
      maintenancedashboard: false,
      showHelpModal: false,
      showLaunchingDashboard: 2,
    };
    // console.log(this.mapShow);

  
  }



 updateDashboard = (value) => {
    const encodedCookieData = this.cookies.get("data");
    const decodedCookieData = JSON.parse(base64_decode(encodedCookieData));
    decodedCookieData.showLaunchingDashboard = value;
    console.log(decodedCookieData, "decoded cookidata");
    const updatedEncodedCookieData = base64_encode(
      JSON.stringify(decodedCookieData)
    );
    this.cookies.set("data", updatedEncodedCookieData, { path: "/" });
    //this.setState({ update: 1 });
  };

  handleRedirect = (dashboardType, path) => {
    this.updateDashboard(dashboardType);
    this.props.navigate(path);
  };


  componentDidMount() {
    const data = JSON.parse(base64_decode(this.cookies.get("data")));
    this.setState({ name: data.userName });
    this.getFleetCount();
  }


  getFleetCount =async (value) => {
      this.setState({loading:true})
    await this.DistributorFleetCountStore.loadData({
      userId: this.props.getUserData().userId,
      companyId: this.props.getUserData().userCompanyId,
      type: "otherCategory"
    });

     await this.setState({ update: 1,loading:false});
  };


  render() {
    const formItemStyle = { marginBottom: "2px", marginTop: "2px" };
    

    return (
        <>
       <Spin spinning={this.state.loading}>
        <div className="othercatapp-container">
          <div className="login-overlay">


            {/* Logo Section */}
            <div className="container mt-4 d-flex">
              <div className="w-75">
                <i
                  class="bi bi-arrow-left-circle"
                  style={{
                    color: "white",
                    fontSize: "25px",
                    marginInlineStart: "25px",
                  }}
                  onClick={async () => {
                    this.props.navigate("/DistributorCertificate")
                  }}
                ></i>
              </div>
              <div className="headtitle w-100" style={{ textAlign: 'center' }}>
                <Title style={{ marginTop: '10%', color: 'white', fontSize: '50px' }}>
                  OTHER CATEGORY
                </Title>
              </div>
              <div className="w-75 d-flex text-end">
                <Image
                  src={require('../assets/images/swd-dashboard-st.png')}
                  alt="SecureTrackX"
                  preview={false}
                  className="certiLogo"
                />
              </div>
            </div>

            <Title level={5} className="white-text distributor-title" style={{ marginBottom: '5px', color: 'white' }}>
              {this.state.name}
            </Title>


            {/* Login Circles */}
            <div className="distlogin-section">
              {/* SecurePath Circle */}
              <div className="d-flex gap-10">
                <div className="certinner-circle1 login-circle "
                  onClick={() => this.handleRedirect(0, "/vehiclelist/1_otherCategory")}
                  style={{ cursor: "pointer" }}>
                  <div className="certinner-1 text-center">
                    <div>
                      <Image
                        src={require('../assets/images/st-monitor-renew.png')}
                        alt="SecurePath"
                        preview={false}
                        className="circle-logo"
                        height={"38px"}
                      />
                      <Title level={5} className="white-text" style={{ marginBottom: '5px', color: 'white' }}>
                        INSTALLED FLEET
                      </Title>
                      <span style={{ color: '#FFF', padding: '0px 8px', fontSize: '0.75rem', }}>
                        {this.DistributorFleetCountStore.vehicles?.installedCount}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="certinner-circle2 login-circle"
                  onClick={() => this.handleRedirect(0, "/vehiclelist/2_otherCategory")}
                  style={{ cursor: "pointer" }}>
                  <div className="certinner-2 text-center">
                    <div>
                      <Image
                        src={require('../assets/images/st-monitor-renew.png')}
                        alt="SecurePath"
                        preview={false}
                        className="circle-logo"
                        height={"38px"}
                      />
                      <Title level={5} className="white-text" style={{ marginBottom: '5px', color: 'white' }}>
                        UNINSTALLED FLEET
                      </Title>
                      <span style={{ color: '#FFF', padding: '0px 8px', fontSize: '0.75rem', }}>
                        {this.DistributorFleetCountStore.vehicles?.notInstalledCount}
                      </span>
                    </div>
                  </div>
                </div>


                <div className="certinner-circle3 login-circle"
                  onClick={() => this.handleRedirect(0, "/vehiclelist/3_otherCategory")}
                  style={{ cursor: "pointer" }}>
                  <div className="certinner-3 text-center">
                    <div>
                      <Image
                        src={require('../assets/images/st-monitor-renew.png')}
                        alt="SecurePath"
                        preview={false}
                        className="circle-logo"
                        height={"38px"}
                      />
                      <Title level={5} className="white-text" style={{ marginBottom: '5px', color: 'white' }}>
                        EXPIRED FLEET
                      </Title>
                      <span style={{ color: '#FFF', padding: '0px 8px', fontSize: '0.75rem', }}>
                        {this.DistributorFleetCountStore.vehicles?.expiredCount}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="certinner-circle4 login-circle"
                  onClick={() => this.handleRedirect(0, "/vehiclelist/0_otherCategory")}
                  style={{ cursor: "pointer" }}>
                  <div className="certinner-4 text-center">
                    <div>
                      <Image
                        src={require('../assets/images/st-monitor-renew.png')}
                        alt="SecurePath"
                        preview={false}
                        className="circle-logo"
                        height={"38px"}
                      />
                      <Title level={5} className="white-text" style={{ marginBottom: '5px', color: 'white' }}>
                        ACTIVE FLEET
                      </Title>
                      <span style={{ color: '#FFF', padding: '0px 8px', fontSize: '0.75rem' }}>
                        {this.DistributorFleetCountStore.vehicles?.activeCount}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </Spin>
   </>
    );
  }
}
CertificateOtherCategories.contextType = StoreContext;
export default observer(withRouter(CertificateOtherCategories));
